import { useMediaQuery, useTheme } from '@mui/material'

const useScreenSize = (customBreakpoint?: number) => {
  const { breakpoints } = useTheme()
  const isTablet = useMediaQuery(breakpoints.down('md'))
  const isMobile = useMediaQuery(breakpoints.down('sm'))
  const isCustomBreakpoint = useMediaQuery(breakpoints.down(customBreakpoint as number))

  return { isTablet, isMobile, isCustomBreakpoint }
}

export default useScreenSize
